module.exports = __webpack_public_path__ + "img/balloon_ride.9219e846.svg";